export class SqsQueuePolicyProbeResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "status",
            "baseName": "status",
            "type": "SqsQueuePolicyProbeStatus",
            "format": ""
        },
        {
            "name": "warnings",
            "baseName": "warnings",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "error",
            "baseName": "error",
            "type": "SqsQueuePolicyProbeError",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SqsQueuePolicyProbeResponse.attributeTypeMap;
    }
    constructor() {
    }
}
